import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleTask } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheTaskComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const taskCombo = computed(() => {
    const tasks = store.getters[`${ModuleTask}/items`];
    return tasks.filter(x => !x.inactive && !x.is_parent);
  });

  // config columns combo
  const cacheTaskComboConfig = reactive({
    data: taskCombo,
    columns: [
      {
        title: 'Mã nhiệm vụ',
        dataField: 'task_code',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nhiệm vụ',
        dataField: 'task_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'task_code',
    valueField: 'task_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'task_id',
      titleSearch: 'Tìm nhanh nhiệm vụ',
    },
  });

  return {
    cacheTaskComboConfig,
  };
};
